import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import { styled } from '@zenbusiness/zui/styles';

export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
  margin: '0',
  padding: '24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    padding: '32px'
  }
}));
